<script context="module"></script>

<script>import { isEditing } from "../../functions/is-editing";
export let blocks;
export let parent;
export let path;
export let styleProp;
export let BlocksWrapperProps;
export let BlocksWrapper;
function stringifyStyles(stylesObj) {
    let styles = "";
    for (let key in stylesObj) {
        const dashedKey = key.replace(/[A-Z]/g, function (match) {
            return "-" + match.toLowerCase();
        });
        styles += dashedKey + ":" + stylesObj[key] + ";";
    }
    return styles;
}
function onClick() {
    if (isEditing() && !blocks?.length) {
        window.parent?.postMessage({
            type: "builder.clickEmptyBlocks",
            data: {
                parentElementId: parent,
                dataPath: path,
            },
        }, "*");
    }
}
function onMouseEnter() {
    if (isEditing() && !blocks?.length) {
        window.parent?.postMessage({
            type: "builder.hoverEmptyBlocks",
            data: {
                parentElementId: parent,
                dataPath: path,
            },
        }, "*");
    }
}
$: className = () => {
    return "builder-blocks" + (!blocks?.length ? " no-blocks" : "");
};
</script>

<svelte:element
  this={BlocksWrapper}
  style={stringifyStyles(styleProp)}
  class={className() + " svelte-element"}
  builder-path={path}
  builder-parent-id={parent}
  {...{}}
  on:click={(event) => {
    onClick();
  }}
  on:mouseenter={(event) => {
    onMouseEnter();
  }}
  on:keypress={(event) => {
    onClick();
  }}
  {...BlocksWrapperProps}><slot /></svelte:element
>

<style>
  .svelte-element {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
</style>